import { useState } from 'react';

import { TournamentsList } from '@features/club/ui/TournamentsList/TournamentsList';
import { useTournamentsListQuery } from '@features/shared/api/public';
import { ClockControlType, TournamentMode } from '@features/shared/api/typings';

export function TournamentsListWidget() {
  const [query, setQuery] = useState('');
  const [clockControl, setClockControl] = useState<ClockControlType>();
  const [mode, setMode] = useState<TournamentMode>();
  const {
    data: tournaments,
    fetchNextPage,
    hasNextPage,
    isPending,
  } = useTournamentsListQuery({
    clockControl,
    mode,
    query,
    limit: 20,
  });

  return (
    <TournamentsList
      bulletEnabled={false}
      tournaments={tournaments}
      query={query}
      clockControl={clockControl}
      mode={mode}
      onModeChange={setMode}
      onQueryChange={setQuery}
      onClockControlChange={setClockControl}
      onLoadMore={hasNextPage ? fetchNextPage : undefined}
      isLoading={isPending}
    />
  );
}
